import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response, Request, RequestOptions, URLSearchParams, RequestMethod } from '@angular/http';
import { Observable, ReplaySubject, Subject, forkJoin } from 'rxjs';
import * as allModels from './models'
import {AdaptersService} from '../../BaseFramework/core/http/adapters.service'

@Injectable()
export class PolicyTranformService {

    constructor(private adapterService:AdaptersService) { }

    policyModel
    tempLeadRefNum
    productPlanList
    BASEPLAN
    exceptionList
    scheduleList
    productList
    appliedForSeatingCapacity
    

    transformServerDOtoUIDO(policyIO) {
        policyIO = this.adapterService.transformQuoteEditRequest(policyIO);
        this.policyModel.isEditMode = true;
        // this.policyModel.name = policyIO.clientDOs[0].personDO.firstName;
        // this.policyModel.email = policyIO.clientDOs[0].clientEmailList[0].emailId;
        // this.policyModel.mobile = policyIO.clientDOs[0].clientContactDetailsList[0].contactNum;
    
        this.policyModel.make = policyIO.vehicleDOs[0].vehicleMakeCd
        this.policyModel.model = policyIO.vehicleDOs[0].vehicleModelCd;
        this.policyModel.variant = policyIO.vehicleDOs[0].vehicleVariant
        this.policyModel.seatingCapacity = policyIO.vehicleDOs[0].seatingCapacity
        this.policyModel.bodyType = policyIO.vehicleDOs[0].bodyTypeCd
        this.policyModel.usage = policyIO.vehicleDOs[0].usagePurpose;
        this.policyModel.plateNumber = policyIO.vehicleDOs[0].registrationNum
        this.policyModel.region = policyIO.vehicleDOs[0].zoneCd
        this.policyModel.manufacturingYear = policyIO.vehicleDOs[0].manufacturingDt;
    
        policyIO.quotationContainerDO.quotationList.forEach(quote => {
          this.tempLeadRefNum = quote.leadRefNum;
          quote.quotationCoverageList.forEach(coverage => {
            if (coverage.planTypeCd == this.BASEPLAN) {
              coverage.quotationCoverageInsuredList.forEach(quotationCoverageInsured => {
                this.policyModel.category = quotationCoverageInsured.ageCategoryCd;
                this.appliedForSeatingCapacity = quotationCoverageInsured.appliedForSeatingCapacity;
              })
            }
          })
    
        })
    
        //this.policyModel.category = policyIO.quotationContainerDO.quotationList[0].quotationCoverageList[0].quotationCoverageInsuredList[0].ageCategoryCd;
        this.policyModel.sumInsured = policyIO.quotationContainerDO.quotationList[0].sumInsured
        this.policyModel.startDate = policyIO.quotationContainerDO.quotationList[0].policyCommencementDt
        this.policyModel.endDate = policyIO.quotationContainerDO.quotationList[0].policyExpiryDt
        this.policyModel.ratingType = policyIO.quotationContainerDO.quotationList[0].ratingTypeCd
        this.policyModel.estimatedPrice = policyIO.quotationContainerDO.quotationList[0].estimatedPrimaryInsuredValue;
    
        this.exceptionList = policyIO.quotationContainerDO.quotationList[0].exceptionDOList;
        this.exceptionList.forEach(exception => {
          exception.productId = policyIO.quotationContainerDO.quotationList[0].baseProductCd;
          exception.plan = policyIO.quotationContainerDO.quotationList[0].productPlanOptionCd;
        });
        //Extracting Products Selected
    
        this.productList.forEach(product => {
          policyIO.quotationContainerDO.quotationList.forEach(quotation => {
            if (quotation.baseProductCd === product.productId) {
              product.checked = true;
              //PlanImpact
              this.setPlans(product)
            }
          })
        })
    
        //PlanImpact
        //Extracting Plans Selected - #PlanImpact New Addition
        this.productPlanList.forEach(product => {
          policyIO.quotationContainerDO.quotationList.forEach(quotation => {
            if (quotation.productPlanOptionCd === product.planOptionCd
              && quotation.baseProductCd === product.productId) {
              product.checked = true;
            }
          })
        })
    
    
        //Extracting Schedules
        policyIO.quotationContainerDO.quotationList[0].quotationCoverageList.forEach(coverage => {
          if (coverage.planTypeCd === this.BASEPLAN) {
            this.scheduleList = coverage.quotationCoverageScheduleList;
          }
        })
    
        this.policyModel.quotationListForEditMode = policyIO.quotationContainerDO.quotationList;
    
        this.policyModel.discount = policyIO.quotationContainerDO.quotationList[0].premiumBreakupList[0].discountPrct;
    
    
    
      }

      setPlans(product) {
        if (product.checked)
          this.createProductPlanList(product);
        else {
          this.removeProductPlanFromList(product);
        }
      }

      createProductPlanList(a){}
    removeProductPlanFromList(a){}

}
